export const createChapter = (params, body) => ({
  data: {
    chapter: {
      id: Math.floor(Math.random() * 200) + 1,
      name: body.name,
      description: body.description,
      image_url: null,
      start_lesson_id: null,
      lessons: [],
    },
  },
  status: 200,
});

export const updateChapter = (params, body) => ({
  data: {
    chapter: {
      id: params.pk,
      name: body.name,
    },
  },
  status: 200,
});
